import { addToCart } from '../../utils/add-to-cart';
import { init as boldSubscriptionInit } from '../../templates/pdp/bold-subscription-widget';
import { getSampleButtonText, shouldDisabledSampleButton, updateAllSampleButtons, updateCartCounter } from '../product-samples/product-samples';
import { updateCartWarning } from '../../templates/cart';
import { showCartSideDraw } from '../../sections/cart-drawer';

export const AddToCartButton = {
  name: 'quickshop-add-to-cart-button',
  template: `#quickshop-add-to-cart-button`,
  props: [
    'qty',
    'selectedVariantId',
    'quickshopIsOpen',
    'isAvailable',
    'productHandle',
    // #679 -- When the parent's `sizeNotSelected` computed is true (multi-size
    // product, no size picked yet), the button renders "Please Select a Size"
    // instead of "Out of Stock". The parent (sidebar-component) gates
    // `isValidVariant` on `!sizeNotSelected` so the button stays disabled.
    'sizeNotSelected',
  ],
  data: () => ({
    cartButtonText: 'Add to Bag',
    addingToCartText: 'Adding to bag...',
    disabled: false,
    addedToCart: false,
    isAdding: false,
    hasContentSquareTrackingClassname: false,
    outOfStockButtonText: 'Out of Stock',
    selectSizeButtonText: 'Please Select a Size',
  }),
  methods: {
    onClickHandler: async function (e) {
      e.preventDefault();
      const _self = this;

      // #679 -- Defense-in-depth guard. The `:disabled="!isAvailable"` binding on
      // the button already prevents click delivery when the parent's
      // `isValidVariant` (which folds in `!sizeNotSelected`) is false, but a
      // programmatic .click() or assistive-tech bypass could still reach this
      // handler. Re-check here so a multi-size Quick Shop with no size picked
      // never calls addToCart() with a stale or first-variant id.
      if (!this.isAvailable) return;

      if (this.addedToCart) {
        window.location = '/checkout';
        return;
      }

      if (this.isAdding) return;

      _self.isAdding = true;

      boldSubscriptionInit(document.querySelector('#quickshop_product_form'))
      const toggleSource = this.$root.xsellOptions?.source || '';
      addToCart({
        quantity: this.qty,
        productHandle: this.productHandle,
        selectedVariantID: this.selectedVariantId,
        source: toggleSource,
      });

      $(document).one('cart.requestComplete', function (event, cart) {
        _self.isAdding = false;
        _self.$emit('cart-added');
        showCartSideDraw();
        const text = getSampleButtonText(this.selectedVariantId);
        _self.disabled = shouldDisabledSampleButton(text);
        _self.cartButtonText = 'Continue to Checkout';
        _self.addedToCart = true;
        _self.hasContentSquareTrackingClassname = true;
        setTimeout(() => {
          updateAllSampleButtons();
          updateCartWarning();
          updateCartCounter(cart);
        }, 1000);
      });

      // Fallback: reset loading state if cart.requestComplete does not fire (e.g. network error)
      setTimeout(() => {
        if (_self.isAdding) _self.isAdding = false;
      }, 5000);
    },
    resetAddToCartCTA: function () {
      this.cartButtonText = 'Add to Bag';
      this.addedToCart = false;
      this.isAdding = false;
      this.hasContentSquareTrackingClassname = false;
      this.disabled = false;
    },
  },
  watch: {
    quickshopIsOpen: function (newVal, oldVal) {
      /**
       * Reset the Quickshop Add To Cart CTA
       * We only want to call this when an item has been added to the cart
       * and when the user has reopened the quickshop sidebar
       */
      if (this.addedToCart && newVal === true) {
        this.resetAddToCartCTA();
      }
    },
  },
};
